/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Hour_ShortInputs */

const en_admin_external_booking_edit_hour_short = /** @type {(inputs: Admin_External_Booking_Edit_Hour_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`h`)
};

const de_admin_external_booking_edit_hour_short = /** @type {(inputs: Admin_External_Booking_Edit_Hour_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`h`)
};

const es_admin_external_booking_edit_hour_short = /** @type {(inputs: Admin_External_Booking_Edit_Hour_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`h`)
};

const fr_admin_external_booking_edit_hour_short = /** @type {(inputs: Admin_External_Booking_Edit_Hour_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`h`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Hour_ShortInputs) => LocalizedString} */
const it_admin_external_booking_edit_hour_short = en_admin_external_booking_edit_hour_short;

/** @type {(inputs: Admin_External_Booking_Edit_Hour_ShortInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_hour_short = en_admin_external_booking_edit_hour_short;

/** @type {(inputs: Admin_External_Booking_Edit_Hour_ShortInputs) => LocalizedString} */
const pl_admin_external_booking_edit_hour_short = en_admin_external_booking_edit_hour_short;

/** @type {(inputs: Admin_External_Booking_Edit_Hour_ShortInputs) => LocalizedString} */
const hu_admin_external_booking_edit_hour_short = en_admin_external_booking_edit_hour_short;

/** @type {(inputs: Admin_External_Booking_Edit_Hour_ShortInputs) => LocalizedString} */
const ro_admin_external_booking_edit_hour_short = en_admin_external_booking_edit_hour_short;

/**
* | output |
* | --- |
* | "h" |
*
* @param {Admin_External_Booking_Edit_Hour_ShortInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_hour_short = /** @type {((inputs?: Admin_External_Booking_Edit_Hour_ShortInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Hour_ShortInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_hour_short(inputs)
	if (locale === "de") return de_admin_external_booking_edit_hour_short(inputs)
	if (locale === "es") return es_admin_external_booking_edit_hour_short(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_hour_short(inputs)
	if (locale === "it") return it_admin_external_booking_edit_hour_short(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_hour_short(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_hour_short(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_hour_short(inputs)
	return ro_admin_external_booking_edit_hour_short(inputs)
});
export { admin_external_booking_edit_hour_short as "admin.external_booking_edit.hour_short" }